export const pluginPrefix = 'PLUGIN:ENV_FEE:';
export const SEND_SMS = `${pluginPrefix}SEND_SMS`;
export const SET_PHONE_NUMBER_FOR_SMS = `${pluginPrefix}SET_PHONE_NUMBER_FOR_SMS`;
export const SET_SALE_ITEMS = `${pluginPrefix}SET_SALE_ITEMS`;
